<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1>ویرایش دوره</h1>
          <b-row v-if="courseDetails">
            <b-col cols="12" md="6">
              <b-form @submit.prevent>
                <b-form-group label="انتخاب زبان دوره" label-for="lang">
                  <v-select
                    id="lang"
                    dir="rtl"
                    v-if="languagesList"
                    :reduce="(persianTitle) => persianTitle.languageId"
                    v-model="courseDetails.languageId"
                    :options="languagesList"
                    label="persianTitle"
                    placeholder="زبان مورد نظر را انتخاب کنید"
                  >
                    <template #no-options
                      >هیچ زبانی جهت نمایش وجود ندارد</template
                    >
                  </v-select>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="12" md="6">
              <b-form @submit.prevent>
                <b-form-group label="انتخاب سطح دوره" label-for="courseType">
                  <v-select
                    id="courseType"
                    dir="rtl"
                    v-if="courseTypes"
                    :reduce="(title) => title.courseTypeId"
                    v-model="courseDetails.courseTypeId"
                    :options="courseTypes"
                    label="title"
                    placeholder="سطح مورد نظر را انتخاب کنید"
                  >
                    <template #no-options
                      >هیچ سطحی جهت نمایش وجود ندارد</template
                    >
                  </v-select>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="12" md="6">
              <b-form @submit.prevent>
                <b-form-group label="پیش نیاز دوره" label-for="courseId">
                  <v-select
                    id="courseId"
                    dir="rtl"
                    v-if="courseList"
                    :reduce="(title) => title.courseId"
                    v-model="courseDetails.dependency"
                    :options="courseList"
                    label="title"
                    placeholder="پیش نیاز این دوره نظر را انتخاب کنید"
                  >
                    <template #no-options
                      >هیچ پیش نیازی جهت نمایش وجود ندارد</template
                    >
                  </v-select>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="12" md="6">
              <b-form @submit.prevent>
                <b-form-group label="نام دوره" label-for="title">
                  <b-form-input
                    id="title"
                    v-model="courseDetails.title"
                    trim
                    placeholder="نام دوره"
                  />
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="12" md="6">
              <b-form @submit.prevent>
                <b-form-group label="توضیحات زمان دوره" label-for="duration">
                  <b-row>
                    <b-col cols="12" md="6">
                      تعداد ساعت
                      <b-form-input
                        id="duration"
                        v-model="durationHourSplited"
                        trim
                        placeholder="8"
                      />
                    </b-col>
                    <b-col cols="12" md="6">
                      تعداد دقیقه
                      <b-form-input
                        id="duration"
                        v-model="durationMinuteSplited"
                        trim
                        placeholder="15"
                      />
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="12" md="6">
              <b-form @submit.prevent>
                <b-form-group label="عکس دوره" label-for="imageFile">
                  <b-form-file
                    ref="imageInput"
                    id="imageFile"
                    @input="convertImageFileToBase64"
                    accept="image/*"
                  ></b-form-file>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col cols="12" md="6">
              <div>
                <div class="position-relative" v-if="imagePreview">
                  <img
                    style="width: 100%; max-height: 10rem; object-fit: contain"
                    :src="imagePreview"
                    alt=""
                  />
                  <feather-icon
                    icon="Trash2Icon"
                    size="25"
                    class="text-danger position-absolute"
                    style="left: 1rem; top: 1rem; cursor: pointer"
                    @click="deletePreviewImage"
                  />
                </div>
              </div>
            </b-col>
            <b-col cols="12">
              <b-form-group label="دسته بندی های دوره">
                <b-row>
                  <b-col cols="4" md="2">
                    <b-form-checkbox
                      v-model="courseDetails.vocabScore"
                      id="vocabScore"
                      class="custom-control-primary mt-1"
                    >
                      <small> دایره کلمات </small>
                    </b-form-checkbox>
                    <b-form-checkbox
                      v-model="courseDetails.grammerScore"
                      id="grammerScore"
                      class="custom-control-primary mt-1"
                    >
                      <small> گرامر </small>
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="4" md="2">
                    <b-form-checkbox
                      v-model="courseDetails.speedScore"
                      id="speedScore"
                      class="custom-control-primary mt-1"
                    >
                      <small> سرعت </small>
                    </b-form-checkbox>
                    <b-form-checkbox
                      v-model="courseDetails.accentScore"
                      id="accentScore"
                      class="custom-control-primary mt-1"
                    >
                      <small> لحجه </small>
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="4" md="2">
                    <b-form-checkbox
                      v-model="courseDetails.pronunciationScore"
                      id="pronunciationScore"
                      class="custom-control-primary mt-1"
                    >
                      <small> تلفظ </small>
                    </b-form-checkbox>
                    <b-form-checkbox
                      v-model="courseDetails.listeningScore"
                      id="listeningScore"
                      class="custom-control-primary mt-1"
                    >
                      <small> شنیداری </small>
                    </b-form-checkbox>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <small>خلاصه دوره</small>
              <quillEditor
                class="mt-1"
                v-model="courseDetails.description"
                :options="editorOption"
              />
            </b-col>
          </b-row>
          <hr />
          <div class="d-flex align-items-center">
            <h2>درس های این دوره</h2>
          </div>
          <app-collapse v-if="defaultLessons">
            <app-collapse-item
              v-for="(item, index) in defaultLessons"
              :key="index"
              class="my-1"
              :title="item.title"
            >
              <b-form class="p-2" @submit.prevent>
                <b-row>
                  <b-col cols="12" md="6">
                    <b-form-group
                      label="عنوان جلسه"
                      :label-for="`title${index}`"
                    >
                      <b-form-input
                        :formatter="titleMaxLength"
                        :id="`title${index}`"
                        v-model="defaultLessons[index].title"
                        trim
                        placeholder="عنوان جلسه"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-form-group
                      label="قیمت جلسه"
                      :label-for="`price${index}`"
                      :invalid-feedback="
                        invalidLessonPrice(defaultLessons[index].price)
                      "
                      :state="
                        invalidLessonPriceState(defaultLessons[index].price)
                      "
                    >
                      <b-form-input
                        :state="
                          invalidLessonPriceState(defaultLessons[index].price)
                        "
                        type="number"
                        :id="`price${index}`"
                        v-model="defaultLessons[index].price"
                        trim
                        placeholder="قیمت جلسه"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-form-group
                      class="text-danger"
                      label="توضیحات جلسه"
                      :label-for="`desc${index}`"
                      :invalid-feedback="
                        invalidLessonDescription(
                          defaultLessons[index].description
                        )
                      "
                      :state="
                        invalidLessonDescriptionState(
                          defaultLessons[index].description
                        )
                      "
                    >
                      <b-form-textarea
                        :state="
                          invalidLessonDescriptionState(
                            defaultLessons[index].description
                          )
                        "
                        :id="`desc${index}`"
                        v-model="defaultLessons[index].description"
                      ></b-form-textarea>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6">
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <b-form-group
                        label="جلسه اجباری"
                        :label-for="`isRequired${index}`"
                      >
                        <b-form-checkbox
                          v-model="defaultLessons[index].isRequired"
                          :id="`isRequired${index}`"
                        >
                          جلسه اجباری
                        </b-form-checkbox>
                      </b-form-group>
                      <b-button
                        variant="primary"
                        class="my-1"
                        @click="
                          sendUserToLessonPage(defaultLessons[index].lessonId)
                        "
                      >
                        افزودن رسانه
                      </b-button>
                    </div>
                  </b-col>
                  <BCol cols="12" class="mt-1">
                    <BButton
                      variant="danger"
                      @click="
                        renderDeleteLessonConfirmationDialog(
                          defaultLessons[index]
                        )
                      "
                    >
                      <!-- @click="deleteLesson(defaultLessons[index].lessonId)" -->
                      حذف درس از دوره
                    </BButton>
                  </BCol>
                </b-row>
              </b-form>
            </app-collapse-item>
          </app-collapse>
          <hr />
          <div
            class="d-flex flex-column flex-md-row align-items-md-center justify-content-md-between mt-3"
          >
            <h2>افزودن درس به دوره</h2>
            <b-button variant="success" @click="addNewLesson">
              افزودن درس جدید
            </b-button>
          </div>
          <app-collapse v-if="lessons && lessons.length > 0">
            <app-collapse-item
              v-for="(item, index) in lessons"
              :key="index"
              :title="item.title"
            >
              <b-form class="p-2" @submit.prevent>
                <b-row>
                  <b-col cols="12" md="6">
                    <b-form-group
                      label="عنوان جلسه"
                      :label-for="`title${index}`"
                    >
                      <b-form-input
                        :formatter="titleMaxLength"
                        :id="`title${index}`"
                        v-model="lessons[index].title"
                        trim
                        placeholder="عنوان جلسه"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-form-group
                      label="قیمت جلسه"
                      :label-for="`price${index}`"
                      :invalid-feedback="
                        invalidLessonPrice(lessons[index].price)
                      "
                      :state="invalidLessonPriceState(lessons[index].price)"
                    >
                      <b-form-input
                        type="number"
                        :state="invalidLessonPriceState(lessons[index].price)"
                        :id="`price${index}`"
                        v-model="lessons[index].price"
                        trim
                        placeholder="قیمت جلسه"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-form-group
                      :state="
                        invalidLessonDescriptionState(
                          lessons[index].description
                        )
                      "
                      label="توضیحات جلسه"
                      :label-for="`desc${index}`"
                      :invalid-feedback="
                        invalidLessonDescription(lessons[index].description)
                      "
                    >
                      <b-form-textarea
                        :state="
                          invalidLessonDescriptionState(
                            lessons[index].description
                          )
                        "
                        :id="`desc${index}`"
                        v-model="lessons[index].description"
                      ></b-form-textarea>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-form-group
                      label="جلسه اجباری"
                      :label-for="`isNewRequired${index}`"
                    >
                      <b-form-checkbox
                        v-model="lessons[index].isRequired"
                        :id="`isNewRequired${index}`"
                      >
                        جلسه اجباری
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </app-collapse-item>
          </app-collapse>
          <hr />
          <p v-if="lessons && lessons.length == 0" class="text-center">
            در حال حاضر هیچ کلاسی جهت نمایش وجود ندارد
          </p>
          <!-- Object type 1 is for course, 2 is for lesson -->
          <property-section
            ref="property"
            v-if="courseDetails"
            :courseTypeId="courseDetails.courseTypeId"
            :objectType="1"
          ></property-section>
          <div class="d-flex align-items-center justify-content-end">
            <b-button
              variant="primary"
              class="my-2"
              @click="sendUpdateCourseRequest"
            >
              بروزرسانی
            </b-button>
          </div>
          <DeleteLessonFromCourseConfirmationDialog
            :selectedLessonDetails="tempSelectedLesson"
            @refetch="getAllLessons"
          ></DeleteLessonFromCourseConfirmationDialog>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
export default {
  mounted() {
    this.getACourse();
    this.getAllLanguages();
    this.getAllCourseTypes();
    this.getAllCourses();
    this.getAllLessons();
  },
  data() {
    return {
      courseDetails: null,
      languagesList: null,
      courseTypes: null,
      courseList: null,
      isLoading: false,
      lessons: [],
      defaultLessons: null,
      lastPriority: null,
      courseImage: null,
      tempBase64: null,
      editorOption: {
        // Some Quill options...
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"],
            ["link", "image", "video"],
          ],
        },
      },
      tempHour: null,
      tempMinute: null,
      tempSelectedLesson: null,
    };
  },
  methods: {
    renderDeleteLessonConfirmationDialog(selectedLesson) {
      this.tempSelectedLesson = JSON.parse(JSON.stringify(selectedLesson));
      this.$bvModal.show("delete-lesson-from-course-dialog");
    },
    invalidLessonDescriptionState(description) {
      if (description != null && description != "" && description.length > 0) {
        return true;
      }
      return false;
    },
    invalidLessonPrice(price) {
      if (price == null || price == "") {
        return "لطفا قیمت درس را وارد کنید";
      }
    },
    invalidLessonPriceState(price) {
      if (price != null && price != "") {
        return true;
      }
      return false;
    },
    invalidLessonDescription(desc) {
      if (desc == null || desc == "") {
        return "لطفا فیلد توضیحات را وارد کنید";
      }
    },
    titleMaxLength(val) {
      if (val.length > 400) {
        let corrected = val.substring(0, 400);
        return corrected;
      }
      return val;
    },
    sendUserToLessonPage(lessonId) {
      this.$router.push(`/lessons/${lessonId}`);
    },
    deletePreviewImage() {
      if (this.courseDetails.imageFile != this.courseImage) {
        this.tempBase64 = null;
        this.courseImage = this.courseDetails.imageFile;
      } else {
        this.tempBase64 = `${this.courseDetails.imageFile}Delete`;
        this.courseImage = null;
      }
      this.$refs.imageInput.reset();
    },
    convertImageFileToBase64(file) {
      if (file) {
        this.courseImage = file;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async () => {
          this.tempBase64 = reader.result.split(",")[1];
        };
      }
    },
    async getAllLessons() {
      let _this = this;
      let getAllLessonsOfCourse = new GetAllLessonsOfCourse(_this);
      getAllLessonsOfCourse.setRequestParam({
        pageNumber: 0,
        count: 0,
        courseId: _this.$route.params.id,
      });
      await getAllLessonsOfCourse.fetch(
        function (response) {
          _this.defaultLessons = response.data.lessons;
          _this.lastPriority = _this.defaultLessons.length;
        },
        function (error) {
          console.error(error);
        }
      );
    },
    async createLessonList() {
      if (this.lessons && this.lessons.length > 0) {
        let _this = this;
        let createLessonList = new CreateLessonList(_this);
        createLessonList.setRequestParamDataObj(_this.lessons);
        try {
          await createLessonList.fetch(
            function (response) {
              if (response > 0) {
                _this.lessons = [];
                _this.getAllLessons();
              }
            },
            function (error) {
              _this.$toast({
                component: ToastificationContent,
                position: "bottom-center",
                props: {
                  title: `توجه`,
                  icon: "",
                  variant: "danger",
                  text: `اطلاعات درس ها صحیح نمی‌باشد.`,
                },
              });
            }
          );
        } catch (error) {
          this.$toast({
            component: ToastificationContent,
            position: "bottom-center",
            props: {
              title: `توجه`,
              icon: "",
              variant: "danger",
              text: `اطلاعات درس ها صحیح نمی‌باشد.`,
            },
          });
          console.error(error.response);
        }
      }
    },
    addNewLesson() {
      this.lessons.push({
        title: "درس جدید",
        lessonId: 0,
        courseId: this.$route.params.id,
        priority: this.lastPriority + 1,
        dependency: null,
        languageId: this.courseDetails.languageId,
        createDate: new Date(Date.now()),
        isRequired: true,
        imageFiles: [],
        description: null,
        price: null,
      });
      this.lastPriority++;
    },
    async getACourse() {
      try {
        this.isLoading = true;
        let _this = this;
        let getACourse = new GetACourse(_this);
        getACourse.setRequestParam({ id: _this.$route.params.id });
        await getACourse.fetch(function (response) {
          _this.courseDetails = response.data;
          _this.courseImage = response.data.imageFile;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async sendUpdateCourseRequest() {
      this.isLoading = true;
      try {
        let _this = this;
        this.courseDetails.duration = `${this.tempHour}:${this.tempMinute}`;
        if (this.courseDetails.duration == ":") {
          this.courseDetails.duration = null;
        }
        let updateACourse = new UpdateACourse(_this);
        _this.courseDetails.imageFile = _this.tempBase64;
        updateACourse.setRequestParamDataObj(_this.courseDetails);
        await updateACourse.fetch(
          async function (res) {
            if (res.isSuccess) {
              _this.$toast({
                component: ToastificationContent,
                props: {
                  title: "دوره با موفقیت ویرایش شد",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
              await _this.$refs.property.createPropertyList();
              await _this.createLessonList();
              _this.getACourse();
              _this.getAllCourses();
            } else {
              _this.$toast({
                component: ToastificationContent,
                props: {
                  title: "مشکلی پیش آمد!",
                  icon: "XIcon",
                  variant: "danger",
                  text: res.errors || "لطفا دوباره تلاش کنید",
                },
              });
            }
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getAllCourses() {
      let _this = this;
      let getAllCourses = new GetAllCourses(_this);
      getAllCourses.setRequestParam({
        count: 10,
        pageNumber: 1,
      });
      await getAllCourses.fetch(
        function (response) {
          if (response.isSuccess) {
            _this.courseList = response.data.courses;
          }
        },
        function (error) {
          console.error(error);
        }
      );
    },
    async getAllCourseTypes() {
      let _this = this;
      let getCourseTypes = new GetCourseTypes(_this);
      getCourseTypes.setParams({
        count: 10,
        pageNumber: 1,
      });
      await getCourseTypes.fetch(
        function (response) {
          if (response.isSuccess) {
            _this.courseTypes = response.data.courseTypes;
          }
        },
        function (error) {
          console.error(error);
        }
      );
    },
    async getAllLanguages() {
      let _this = this;
      let getAllLanguages = new GetAllLanguages(_this);
      getAllLanguages.setRequestParam({
        count: 10,
        pageNumber: 1,
      });
      await getAllLanguages.fetch(
        function (response) {
          if (response.isSuccess) {
            _this.languagesList = response.data.languages;
          }
        },
        function (error) {
          console.error(error);
        }
      );
    },
  },
  computed: {
    durationHourSplited: {
      set(value) {
        this.tempHour = value;
      },
      get() {
        let time = JSON.parse(JSON.stringify(this.courseDetails?.duration));
        let hour = time?.split(":");
        if (hour && hour[0]) {
          this.tempHour = hour[0];
          return hour[0];
        } else {
          return null;
        }
      },
    },
    durationMinuteSplited: {
      set(value) {
        this.tempMinute = value;
      },
      get() {
        let time = JSON.parse(JSON.stringify(this.courseDetails?.duration));
        let minute = time?.split(":");
        if (minute && minute[1]) {
          this.tempMinute = minute[1];
          return minute[1];
        } else {
          return null;
        }
      },
    },
    imagePreview() {
      if (
        this.courseImage &&
        typeof this.courseImage === "string" &&
        this.courseImage.includes(".")
      ) {
        return `${this.baseUrl}/${this.courseImage}`;
      } else if (
        this.courseImage !== null &&
        typeof this.courseImage === "object"
      ) {
        return URL.createObjectURL(this.courseImage);
      } else {
        return null;
      }
    },
    baseUrl() {
      return process.env.VUE_APP_BASE_URL;
    },
  },
  components: {
    vSelect,
    quillEditor,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BFormFile,
    BForm,
    BFormGroup,
    BFormTextarea,
    BFormCheckbox,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    AppCollapse,
    AppCollapseItem,
    PropertySection,
    DeleteLessonFromCourseConfirmationDialog,
  },
};
import { DeleteALanguage, GetAllLanguages } from "@/libs/Api/Language";
import { GetCourseTypes } from "@/libs/Api/CourseType";
import { CreateLessonList, GetAllLessonsOfCourse } from "@/libs/Api/Lesson";
import { GetACourse, GetAllCourses, UpdateACourse } from "@/libs/Api/Course";
import PropertySection from "@/views/components/Properties/PropertySection.vue";
import vSelect from "vue-select";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import DeleteLessonFromCourseConfirmationDialog from "@/views/components/Course/DeleteLessonFromCourseConfirmationDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormFile,
  BFormTextarea,
  BFormCheckbox,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
</script>
